var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5803",
    "data-name": "Group 5803",
    transform: "translate(-1222 -857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_7120",
    "data-name": "Path 7120",
    transform: "translate(1226 861)",
    fill: "#1a76cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9 20 C 6.061789989471436 20 3.299449920654297 18.85580062866211 1.221830010414124 16.77816963195801 C -0.8557999730110168 14.7005500793457 -2 11.93820953369141 -2 9 C -2 6.061789989471436 -0.8557999730110168 3.299449920654297 1.221830010414124 1.221830010414124 C 3.299449920654297 -0.8557999730110168 6.061789989471436 -2 9 -2 C 11.93820953369141 -2 14.7005500793457 -0.8557999730110168 16.77816963195801 1.221830010414124 C 18.85580062866211 3.299449920654297 20 6.061789989471436 20 9 C 20 11.93820953369141 18.85580062866211 14.7005500793457 16.77816963195801 16.77816963195801 C 14.7005500793457 18.85580062866211 11.93820953369141 20 9 20 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9 0 C 4.029439926147461 0 0 4.029439926147461 0 9 C 0 13.97056007385254 4.029439926147461 18 9 18 C 13.97056007385254 18 18 13.97056007385254 18 9 C 18 4.029439926147461 13.97056007385254 0 9 0 M 9 -4 C 12.47241973876953 -4 15.73701000213623 -2.647760391235352 18.19239044189453 -0.1923904418945312 C 20.64776039123535 2.26298999786377 22 5.527580261230469 22 9 C 22 12.47241973876953 20.64776039123535 15.73701000213623 18.19239044189453 18.19239044189453 C 15.73701000213623 20.64776039123535 12.47241973876953 22 9 22 C 5.527580261230469 22 2.26298999786377 20.64776039123535 -0.1923904418945312 18.19239044189453 C -2.647760391235352 15.73701000213623 -4 12.47241973876953 -4 9 C -4 5.527580261230469 -2.647760391235352 2.26298999786377 -0.1923904418945312 -0.1923904418945312 C 2.26298999786377 -2.647760391235352 5.527580261230469 -4 9 -4 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    transform: "translate(1226 861)",
    fill: "#fff",
    stroke: "#676767",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.f5a06d3f8e8b8616252423d1ca50b3dc.svg";
export { ForwardRef as ReactComponent };